export * from './base-accommodation-info';
export * from './base-accommodation-info.props';
